import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase/firebase.js"; // Adjust the import path as needed

const ProtectedRoute = ({ element: Component }) => {
  if (!auth.currentUser) {
    return <Navigate to="/login" />;
  }
  if (!auth.currentUser.emailVerified) {
    return <Navigate to="/verify-email" />;
  }
  return <Component />;
};

export default ProtectedRoute;
